import { render, staticRenderFns } from "./TextBoxObject.vue?vue&type=template&id=ff3a25b0&scoped=true&"
import script from "./TextBoxObject.vue?vue&type=script&lang=ts&"
export * from "./TextBoxObject.vue?vue&type=script&lang=ts&"
import style0 from "./TextBoxObject.vue?vue&type=style&index=0&id=ff3a25b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3a25b0",
  null
  
)

export default component.exports